<ng-container *ngComponentOutlet="searchFilter injector: objectInjector;"></ng-container>
